import { render, staticRenderFns } from "./AlumniTabContentCompnent.vue?vue&type=template&id=536947c8&"
import script from "./AlumniTabContentCompnent.vue?vue&type=script&lang=js&"
export * from "./AlumniTabContentCompnent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports